import React from 'react';
import {
    Grid,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    FormHelperText,
    Button,
    Box
} from '@mui/material';
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

const AbortionForm = ({ values, errors, touched, handleChange, handleBlur, setFieldValue, isSubmitting, masterData, minDate }) => {
    const { abortionTypeOptions = [] } = masterData;

    return (
        <Box>
            <Grid container spacing={2} sx={{ alignItems: "flex-start" }}>
                {/* Date of Abortion */}
                <Grid size={4}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            views={["year", "month", "day"]}
                            label="Date of Abortion *"
                            format="DD-MM-YYYY"
                            value={values.date_of_abortion ? dayjs(values.date_of_abortion) : null}
                            minDate={minDate ? dayjs(minDate) : undefined}
                            maxDate={dayjs()}
                            onChange={(value) => {
                                setFieldValue('date_of_abortion', value ? value.format('YYYY-MM-DD') : null);
                            }}
                            slotProps={{
                                textField: {
                                    fullWidth: true,
                                    autoComplete: "off",
                                    error: touched.date_of_abortion && Boolean(errors.date_of_abortion),
                                    helperText: touched.date_of_abortion && errors.date_of_abortion,
                                    onBlur: handleBlur,
                                    name: "date_of_abortion",
                                    onDrop: (e) => {
                                        e.preventDefault();
                                        return false;
                                    },
                                },
                            }}
                        />
                    </LocalizationProvider>
                </Grid>

                {/* Abortion Type */}
                <Grid size={4}>
                    <FormControl
                        fullWidth
                        error={touched.abortion_type && Boolean(errors.abortion_type)}
                    >
                        <InputLabel id="abortion_type-label">Abortion Type *</InputLabel>
                        <Select
                            labelId="abortion_type-label"
                            id="abortion_type"
                            name="abortion_type"
                            value={values.abortion_type}
                            label="Abortion Type *"
                            onChange={handleChange}
                            onBlur={handleBlur}
                        >
                            {abortionTypeOptions.map((item) => (
                                <MenuItem key={item} value={item}>
                                    {item}
                                </MenuItem>
                            ))}
                        </Select>
                        {touched.abortion_type && errors.abortion_type && (
                            <FormHelperText>{errors.abortion_type}</FormHelperText>
                        )}
                    </FormControl>
                </Grid>

                {/* Submit Button */}
                <Grid size={12}>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 2 }}>
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            disabled={isSubmitting}
                        >
                            {isSubmitting ? 'Submitting...' : 'Submit'}
                        </Button>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

export default AbortionForm;
